"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeBucketEnd = exports.getTimeBucketStartDateTimeForTimestamp = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const types_1 = require("./types");
const __1 = require("..");
const debug = process.env.REACT_APP_DEBUG && false;
const yearZero = 0;
/** returns the  */
const getTimeBucketStartDateTimeForTimestamp = ({ timestamp, timeBucketDef }) => {
    if ([types_1.TimeBucketUnits.MONTH, types_1.TimeBucketUnits.YEAR].includes(timeBucketDef.unit)) {
        return getVariablePeriodTimeBucketStartDateForTimestamp({ timestamp, timeBucketDef });
    }
    else {
        return getPredictableTimeBucketStartDateTimeForTimestamp({ timestamp, timeBucketDef });
    }
};
exports.getTimeBucketStartDateTimeForTimestamp = getTimeBucketStartDateTimeForTimestamp;
const getVariablePeriodTimeBucketStartDateForTimestamp = ({ timestamp, timeBucketDef }) => {
    const { width, unit } = timeBucketDef;
    let returnDate = new Date('1970-01-01 00:00:00 UTC');
    const tsDate = new Date(timestamp);
    // Find start of containing year / month
    if (unit === types_1.TimeBucketUnits.YEAR) {
        const tsYear = tsDate.getUTCFullYear();
        const q = Math.floor((tsYear - yearZero) / width);
        const bucketYear = q * width;
        returnDate.setUTCFullYear(bucketYear);
    }
    else if (unit === types_1.TimeBucketUnits.MONTH) {
        const yearZeroYrDiff = tsDate.getUTCFullYear() - returnDate.getUTCFullYear();
        const yearZeroMnDiff = tsDate.getUTCMonth() - returnDate.getUTCMonth();
        const monthsDiff = 12 * yearZeroYrDiff + yearZeroMnDiff;
        const q = Math.floor(monthsDiff / width);
        const bucketMonthYrZRelative = q * width;
        returnDate.setUTCMonth(returnDate.getUTCMonth() + bucketMonthYrZRelative);
    }
    // If offset, find the component in surplus of the latest whole year/month
    // If the surplus is less than the offset, the bucket needs to be one year/month behind
    if (timeBucketDef.offset) {
        const surplusComponent = new Date(timestamp).valueOf() - returnDate.valueOf();
        if (surplusComponent < timeBucketDef.offset) {
            // Should be <= ???
            if (unit === types_1.TimeBucketUnits.YEAR) {
                returnDate.setUTCFullYear(returnDate.getUTCFullYear() - 1);
            }
            else if (unit === types_1.TimeBucketUnits.MONTH) {
                returnDate.setUTCMonth(returnDate.getUTCMonth() - 1);
            }
        }
        const returnDateMS = returnDate.valueOf();
        returnDate = new Date(returnDateMS + timeBucketDef.offset);
    }
    return returnDate;
};
const getPredictableTimeBucketStartDateTimeForTimestamp = ({ timestamp, timeBucketDef }) => {
    const { width, unit } = timeBucketDef;
    const period = width * unit;
    debug && console.log('Get Time Bucket Start: Period', period, period / iotv_v3_types_1.Milliseconds.HOUR);
    // Number of periods since the start of time, (which is 00:00 UTC)
    const numWholePeriodsSinceBucketStart = Math.floor(timestamp / period);
    // The number of whole buckets since the start of time is the bucket start timestamp
    // This bucket start is then offset by the offset
    // This adjustment can mean our timestamp is now before the bucket start. In this case, the bucket start is actually one bucket prior
    let bucketStartTimestamp = period * numWholePeriodsSinceBucketStart + (timeBucketDef.offset ?? 0);
    debug && console.log('Get Time Bucket Start: timestamp found', bucketStartTimestamp, (0, __1.getNiceDate)(bucketStartTimestamp));
    if (bucketStartTimestamp > timestamp) {
        //debug && console.log("Get Time Bucket Start: need to adjust by period");
        bucketStartTimestamp -= period; // If offset is a certain number, we need to adjust. It's > and not >= because buckets are exclsuive of their end times
    }
    return new Date(bucketStartTimestamp);
    /*
      const tp = timestamp - period
      const baseline = new Date( tp )
      baseline.setUTCMonth( 0 )
      baseline.setUTCDate( 1 )
      baseline.setUTCHours( 0, 0, 0, 0 )
      let ty = baseline.valueOf();
      if (timeBucketDef.offset) {
          ty += timeBucketDef.offset
      }
      const q = Math.floor( (timestamp - ty) / period )
      debug && console.log( { q, b: baseline.toString(), hours: period / Milliseconds.HOUR })
      const tl = ( ty + q * period )
      const timeBucketStartDateTime = new Date( tl )
      return timeBucketStartDateTime
      */
};
/** returns end of time bucket given start from the above fn, adjusted for non-predicatable units */
const getTimeBucketEnd = ({ timeBucketDef, timeBucketStartTimestamp }) => {
    const { unit, width } = timeBucketDef;
    let timeBucketEnd = timeBucketStartTimestamp;
    if ([types_1.TimeBucketUnits.MONTH, types_1.TimeBucketUnits.YEAR].includes(timeBucketDef.unit)) {
        const refDate = new Date(timeBucketStartTimestamp);
        if (types_1.TimeBucketUnits.MONTH === unit) {
            refDate.setUTCMonth(refDate.getUTCMonth() + width);
        }
        else if (types_1.TimeBucketUnits.YEAR === unit) {
            refDate.setUTCFullYear(refDate.getUTCFullYear() + width);
        }
        timeBucketEnd = refDate.valueOf();
    }
    else {
        timeBucketEnd = timeBucketStartTimestamp + unit * width;
    }
    return timeBucketEnd;
};
exports.getTimeBucketEnd = getTimeBucketEnd;
